import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLongArrowAltRight } from "react-icons/fa";
import { GetVisualPanelList } from "../../api/visualpanel-functions";
import globalVariables from "../../global-variables";
import { Container, Row, Col } from "reactstrap";
import Carousel from "react-bootstrap/Carousel";
import FsLightbox from "fslightbox-react";
import axios from "axios";
import Image from "react-image-webp";
import { HashLink } from "react-router-hash-link";
import Roadblock_Popup from "./roadblock-popup";
import Metatag from "../../hooks/Metatag";
import CookieConsent from "react-cookie-consent";

export default function Home() {
  const [toggler, setToggler] = useState(true);
  const navigate = useNavigate();

  const [index, setIndex] = useState(0);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -134;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };
  //for disease data binding
  // let loopOpen = false;
  // let maxLength = 0;

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const [visualpanels, setVisualpanelList] = useState([]);
  const [news, setNewsList] = useState([]);
  const [event, seteventList] = useState([]);

  // success function when the list is retrived
  const OnGetVisualpanelSuccess = (p_response) => {
    // set the list for looping
    setVisualpanelList(p_response);
  };

  // things to be done when the page is loaded
  useEffect(() => {
    // make the object for getting the visual panel list
    let _objVP = new Object();
    _objVP._visualpanel_id = null;
    _objVP._fieldname = null;
    _objVP._isactive = 1;

    // call the function to get the roadblock
    GetVisualPanelList(_objVP, OnGetVisualpanelSuccess, navigate);

    let newsObj = {
      _news_status: 1,
    };
    //Get news List
    axios
      .post(
        `${globalVariables.variables.strApiUrl}/newsApi/getnewsList`,
        newsObj
      )
      .then((response_list) => {
        if (response_list.data === "error") {
          navigate("/error-page");
        } else {
          // pass the result in the success function of the respective page
          setNewsList(response_list.data[0]);
        }
      });

    //Get upcoming event List
    let _objEvent = new Object();
    _objEvent.event_status = 1;
    _objEvent.event_upcoming = "u";

    axios
      .post(
        `${globalVariables.variables.strApiUrl}/eventApi/geteventList`,
        _objEvent
      )
      .then((response_list) => {
        if (response_list.data === "error") {
          navigate("/error-page");
        } else {
          // pass the result in the success function of the respective page
          seteventList(response_list.data[0]);
        }
      });
  }, []);

  useEffect(() => {
    if (visualpanels.length === 1) {
      $(".carousel-indicators").remove();
    }
  }, [visualpanels]);

  return (
    <>
      <Header main_className="bg-header"></Header>

      {/* Metatag */}
      <Metatag
        title="National Disease Modelling Consortium | Disease Modelling in India | Disease Modellers in India"
        keywords="The National Disease Modelling Consortium - NDMC, Disease Modelling in India, Disease Modellers in India, Malaria Disease Modelling, Tuberculosis Disease Modelling, Vaccine Preventable Diseases Modelling, Neglected Tropical Diseases Modelling, Consolidated Estimates of Disease Occurrence, Consolidated Estimates of Vaccination"
        description="NDMC aims to generate consolidated estimates of disease occurrence and the overall effect of vaccination in the population."
      />

      {/* Slider Container */}
      <div className="container-fluid bg-light px-0 visual-panel">
        <div className="d-md-none d-block">
          <img
            className="img-fluid"
            src={
              global.variables.strDomainUrl +
              "images/visualpanel/mob-visual.jpg"
            }
            alt=""
          />
        </div>
        <div className="visual-container-1920 d-md-block d-none">
          <Carousel
            fade
            activeIndex={index}
            onSelect={handleSelect}
            interval={3000}
            nextIcon={false}
            prevIcon={false}
          >
            {visualpanels.length > 0 ? (
              visualpanels.map((val) => {
                return (
                  <Carousel.Item>
                    <img
                      className="d-block w-100"
                      src={
                        globalVariables.variables.strApiUrl +
                        "/visualpanel/" +
                        val.visualpanel_pic
                      }
                      alt={val.visualpanel_title}
                    />
                    <Carousel.Caption className="slider-caption">
                      <Container className="d-md-block d-none">
                        <div className="caption-container">
                          <h2
                            className="h1 fw-bold"
                            style={{ color: val.visualpanel_title_color }}
                          >
                            {val.visualpanel_title}
                          </h2>
                          {val.visualpanel_caption != null &&
                          val.visualpanel_caption != "" ? (
                            <h4
                              className="lh-normal"
                              style={{ color: val.visualpanel_caption_color }}
                            >
                              {val.visualpanel_caption}
                            </h4>
                          ) : null}
                          <div className="mt-3">
                            {val.visualpanel_link != null &&
                            val.visualpanel_link != "" ? (
                              val.visualpanel_isextlink == "1" ? (
                                <Link
                                  to={val.visualpanel_link}
                                  className="btn btn-danger"
                                  target="_blank"
                                >
                                  Learn More
                                </Link>
                              ) : (
                                <Link
                                  to={val.visualpanel_link}
                                  className="btn btn-danger"
                                >
                                  Learn More
                                </Link>
                              )
                            ) : null}
                          </div>
                        </div>
                      </Container>
                    </Carousel.Caption>
                  </Carousel.Item>
                );
              })
            ) : (
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={
                    global.variables.strDomainUrl +
                    "images/visualpanel/visual1.jpg"
                  }
                  alt=""
                />
                <Carousel.Caption className="slider-caption">
                  <Container className="d-md-block d-none">
                    <div className="caption-container">
                      <h2 className="h1 fw-bold">
                        {/* NDMC aims to generate <br /> consolidated estimates */}
                      </h2>
                      <h4 className="lh-normal">
                        {/* of disease burden and the overall effect <br /> of policy interventions on the population */}
                      </h4>
                      {/* <div className="mt-3">
                        <Link to="" className="btn btn-danger">Learn More</Link>
                      </div> */}
                    </div>
                  </Container>
                </Carousel.Caption>
              </Carousel.Item>
            )}
          </Carousel>
        </div>
      </div>

      {/* Video Container */}
      <div className="container-fluid bg-light px-0 player-wrapper d-none">
        <iframe
          className="react-player border-0"
          width="100%"
          height="100%"
          src="https://www.youtube-nocookie.com/embed/6_q_LHq85Cs?autoplay=1&amp;mute=1&amp;rel=0&amp;controls=0&amp&amp;showinfo=0&amp;modestbranding=1"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
        <img
          src={global.variables.strDomainUrl + "images/video-bg.png"}
          className="img-fluid w-100 bg-video"
          alt=""
          title=""
        />
      </div>

      <div className="home-intro-circle bg-hex ">
        {/* news and event container  */}
        <Container fluid="lg" className="pt-5 ">
          <Row className="row-cols-1 py-4 row-cols-lg-2 gx-xl-5 g-4">
            <Col>
              <div className="border rounded-3 p-4 h-100">
                <h2 className="text-danger fw-bold mb-4">News @ NDMC</h2>
                <ul className="ps-4">
                  {news.slice(0, 3).map((news, index) => {
                    return (
                      <li className="mb-2 fw-bold wow fadeInUp" key={index}>
                        {news.news_date}: {news.news_headline}
                      </li>
                    );
                  })}
                </ul>
                <div className="">
                  <p className="mt-4 wow">
                    <Link to="/news" className="btn btn-slide rounded-pill">
                      Learn More<i className="fa fa-long-arrow-right ms-2"></i>
                    </Link>
                  </p>
                </div>
              </div>
            </Col>
            <Col>
              <div className="border rounded-3 p-4 h-100">
                <h2 className="text-danger fw-bold mb-4">
                  Upcoming Events/Workshops @ NDMC
                </h2>
                <ul className="ps-4">
                  {event.length === 0 ? (
                    <li className="fw-bold wow animated">
                      Upcoming Events/Workshops at NDMC will be available soon. Click the link below to view archives.
                    </li>
                  ) : (
                    event.slice(0, 3).map((event, index) => {
                      return (
                        <li className="fw-bold wow animated">
                          {event.event_from_date === event.event_to_date
                            ? event.event_from_date
                            : event.event_from_date +
                              " to " +
                              event.event_to_date}
                          : {event.event_name}
                        </li>
                      );
                    })
                  )}
                  <div className="">
                    <p className="mt-4 wow">
                      <Link to="/events" className="btn btn-slide rounded-pill">
                        Learn More
                        <i className="fa fa-long-arrow-right ms-2"></i>
                      </Link>
                    </p>
                  </div>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        {/* Intro Container */}
        <Container fluid="lg" className="py-5 position-relative">
          <Row className="py-4">
            <Col xl="8" className="mx-auto text-center position-relative z-1">
              <div>
                <h2 className="text-danger fw-bold wow fadeInUp">
                  National Disease Modelling Consortium (NDMC)
                </h2>
                <p className="wow fadeInUp fw-normal">
                  The National Disease Modelling Consortium (NDMC) is a unique
                  national effort to model various diseases. Established in
                  2022, NDMC is anchored in the Indian Institute of Technology,
                  Bombay, and represents a group of modellers from across the
                  country. NDMC aims to generate consolidated estimates of
                  disease burden and the overall effect of policy interventions
                  on the population.
                </p>

                <h3 className="wow fadeInUp  text-danger fw-bold mt-5">
                  Our Vision
                </h3>
                <p className="wow fadeInUp  m-0 playfair h5">
                  To establish a national centre for cutting edge research to
                  understand disease dynamics and propose policy interventions
                  for disease control. Our research will equip public health
                  officers with optimal strategies to strengthen immunisation
                  coverage and advance disease control and elimination efforts
                  at the national and sub-national levels.
                </p>
              </div>
              <div className="wow fadeInUp  text-center">
                <p className="mt-5">
                  <Link to="/aboutus" className="btn btn-slide rounded-pill">
                    Learn More
                    <FaLongArrowAltRight className="icon-16 ms-2" />
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Four Disease Areas */}
      <div className="research-pannel">
        <Container fluid="lg" className="py-5 diseases">
          <Row className="diseases align-items-center">
            <Col lg="7" md="6" className="pe-lg-5">
              <h2 className="mb-0 wow fadeInUp fw-bold mb-4 pe-lg-5">
                Our Research Currently Focuses on{" "}
                <br className="d-lg-block d-none" />
                Four Disease Areas
              </h2>
              <ul className="listing pe-lg-5">
                <li className="wow fadeInUp">
                  <div className="d-flex">
                    <div className="d-flex align-items-center justify-content-center text-white me-3 num-circle">
                      1
                    </div>
                    <div>
                      <Link
                        to={`${global.variables.strDomainUrl}disease/malaria`}
                        className="fw-bold"
                      >
                        Malaria
                      </Link>
                    </div>
                  </div>
                </li>
                <li className="wow fadeInUp">
                  <div className="d-flex">
                    <div className="d-flex align-items-center justify-content-center text-white me-3 num-circle">
                      2
                    </div>
                    <div>
                      <Link
                        to={`${global.variables.strDomainUrl}disease/tuberculosis`}
                        className="fw-bold"
                      >
                        Tuberculosis
                      </Link>
                    </div>
                  </div>
                </li>
                <li className="wow fadeInUp">
                  <div className="d-flex">
                    <div className="d-flex align-items-center justify-content-center text-white me-3 num-circle">
                      3
                    </div>
                    <div>
                      <b>Vaccine Preventable Diseases (VPDs):</b> <br />
                      <div className="d-lg-flex">
                        <ul className="list fw-normal">
                          <li>Diphtheria</li>
                          <li>Hepatitis B</li>
                          <li>Human papillomavirus</li>
                          <li>Japanese encephalitis</li>
                        </ul>
                        <ul className="list fw-normal ms-xxl-5 ms-xl-3 ms-0">
                          <li>
                            <Link
                              to={`${global.variables.strDomainUrl}disease/measles`}
                            >
                              Measles
                            </Link>
                          </li>
                          <li>Pertussis</li>
                          <li>Pneumococcal disease</li>
                          <li>Polio</li>
                        </ul>
                        <ul className="list fw-normal ms-xxl-5 ms-xl-3 ms-0">
                          <li>Tetanus</li>
                          <li>Typhoid fever</li>
                          <li>Rotavirus</li>
                          <li>Rubella</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="wow fadeInUp">
                  <div className="d-flex">
                    <div className="d-flex align-items-center justify-content-center text-white me-3 num-circle">
                      4
                    </div>
                    <div>
                      <b>Neglected Tropical Diseases (NTDs):</b> <br />
                      <ul className="list fw-normal">
                        <li>
                          <Link
                            to={`${global.variables.strDomainUrl}disease/lymphatic-filariasis`}
                          >
                            Lymphatic filariasis
                          </Link>
                        </li>
                        <li>
                          <HashLink
                            to={`${global.variables.strDomainUrl}disease/visceral-leishmaniasis`}
                            scroll={(el) => scrollWithOffset(el)}
                          >
                            Visceral leishmaniasis (Kala-azar)
                          </HashLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </Col>

            <Col lg="5" md="6" className="text-center py-4 icon-panel">
              <div className="row row-cols-2 g-4 text-center">
                <div className="col">
                  <Link to={`${global.variables.strDomainUrl}disease/malaria`}>
                    <div className="p-md-3 p-2 rounded-3 h-100 position-relative overflow-hidden">
                      <div className="text-center">
                        <figure className="bg-light p-4 rounded-circle">
                          <img
                            loading="lazy"
                            src={
                              global.variables.strDomainUrl +
                              "images/icon-malaria.png"
                            }
                            width="100"
                            height="100"
                            alt="Malaria"
                            title="Malaria"
                            className="img-fluid border-0 rounded-3 wow fadeInUp"
                          />
                        </figure>
                        <h6 className="text-dark wow fadeInUp mb-0">Malaria</h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link
                    to={`${global.variables.strDomainUrl}disease/tuberculosis`}
                  >
                    <div className="p-md-3 p-2 rounded-3 h-100 position-relative overflow-hidden">
                      <div className="text-center">
                        <figure className="bg-light p-4 rounded-circle">
                          <img
                            loading="lazy"
                            src={
                              global.variables.strDomainUrl +
                              "images/icon-tuberclosis.png"
                            }
                            width="100"
                            height="100"
                            alt="Tuberculosis"
                            title="Tuberculosis"
                            className="img-fluid border-0 rounded-3 wow fadeInUp"
                          />
                        </figure>
                        <h6 className="text-dark wow fadeInUp mb-0">
                          Tuberculosis
                        </h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link to={`${global.variables.strDomainUrl}disease/measles`}>
                    <div className="p-md-3 p-2 rounded-3 h-100 position-relative overflow-hidden">
                      <div className="text-center">
                        <figure className="bg-light p-4 rounded-circle">
                          <img
                            loading="lazy"
                            src={
                              global.variables.strDomainUrl +
                              "images/icon-vaccine.png"
                            }
                            width="100"
                            height="100"
                            alt="Vaccine Preventable Diseases (VPD)"
                            title="Vaccine Preventable Diseases (VPD)"
                            className="img-fluid border-0 rounded-3 wow fadeInUp"
                          />
                        </figure>
                        <h6 className="text-dark wow fadeInUp mb-0">
                          Vaccine Preventable <br />
                          Diseases (VPD)
                        </h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col">
                  <Link
                    to={`${global.variables.strDomainUrl}disease/lymphatic-filariasis`}
                  >
                    <div className="p-md-3 p-2 rounded-3 h-100 position-relative overflow-hidden">
                      <div className="text-center">
                        <figure className="bg-light p-4 rounded-circle">
                          <img
                            loading="lazy"
                            src={
                              global.variables.strDomainUrl +
                              "images/icon-neglected-diseases.png"
                            }
                            width="100"
                            height="100"
                            alt="Neglected Tropical Diseases (NTDs)"
                            title="Neglected Tropical Diseases (NTDs)"
                            className="img-fluid border-0 rounded-3 wow fadeInUp"
                          />
                        </figure>
                        <h6 className="text-dark wow fadeInUp mb-0">
                          Neglected Tropical <br />
                          Diseases (NTDs)
                        </h6>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Roadblock_Popup />
      <CookieConsent
        location="bottom"
        buttonText="GOT IT"
        buttonClasses="btn  rounded-pill"
        containerClasses="cookie-wrapper"
        contentClasses="cookie-content"
        cookieName="cookiesAccepted"
        expires={150}
        className="cookie-popup-inner"
        buttonStyle={{}}
      >
        We use cookies to ensure that we give you the best experience and to
        analyze our website traffic and performance; we never collect any
        personal data.
      </CookieConsent>
    </>
  );
}
